import { useContext } from "react";
import AuthContext from "../context/AuthProvider";

// custom hook to exploit code reusability
const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
